export default __webpack_public_path__ + "images/525d655f4b6740c87902d27b81b482e3-nye_header_desktop.webp";